import { render, staticRenderFns } from "./NearbyStopsSection.vue?vue&type=template&id=700ca199&scoped=true"
import script from "./NearbyStopsSection.vue?vue&type=script&lang=js"
export * from "./NearbyStopsSection.vue?vue&type=script&lang=js"
import style0 from "./NearbyStopsSection.vue?vue&type=style&index=0&id=700ca199&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ca199",
  null
  
)

export default component.exports